const { recordLink, recordLinkV2, recordPage }= require('utilities/tagging');
const { 
    LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    TAGGING_VIEW,
    TAG_EVENT_OPEN,
    TAG_EVENT_CLOSE,
    CLICK_BUTTON_ACTION,
    CLICK_LINK_EVENT,
    TAG_DOWNLOAD,
    TAG_PRINT,
    TAG_PREVIOUS,
}= require('../../../../loansConstants');

export const analyticsId = {
    CONTRACT_EASY_LOAN_STEP_1_VIEW: "CONTRACT_EASY_LOAN_STEP_1_VIEW",
    CONTRACT_EASY_LOAN_STEP_2_VIEW: "CONTRACT_EASY_LOAN_STEP_2_VIEW",
    CONTRACT_EASY_LOAN_STEP_3_VIEW: "CONTRACT_EASY_LOAN_STEP_3_VIEW",
    CONTRACT_EASY_LOAN_STEP_1_SUCCESS: "CONTRACT_EASY_LOAN_STEP_1_SUCCESS",
    CONTRACT_EASY_LOAN_STEP_2_SUCCESS: "CONTRACT_EASY_LOAN_STEP_2_SUCCESS",
    CONTRACT_EASY_LOAN_STEP_3_SUCCESS: "CONTRACT_EASY_LOAN_STEP_3_SUCCESS",
    CONTRACT_EASY_LOAN_WIZARD_ERROR: "CONTRACT_EASY_LOAN_WIZARD_ERROR",
    CONTRACT_EASY_LOAN_WIZARD_SUCCESS: "CONTRACT_EASY_LOAN_WIZARD_SUCCESS",
    CONTRACT_EASY_LOAN_WIZARD_NO_OFFER: "CONTRACT_EASY_LOAN_WIZARD_NO_OFFER",
    CLICK_BREADCRUMB_01: "CLICK_BREADCRUMB_01",
    PRUPOSE_DROPDOWN_EVENT: "pruposeDropdown",
    CLICK_TEXT_BOX_EVENT: "clickTextBox",
    EASY_LOAN_REQUEST: "solicitud aprobada prestamo",
    TAG_SCROLL_TO_BOTTON: "scrollToBottom",
    TAG_CHECKED: "checked", 
    TAG_UNCHECKED: "unchecked",
};

const commonFields = () => ({
    sectionFamily: "banking",
    sectionCategory: "products",
    sectionName: "loans",
    serviceType: "productContracting",
    interactionType: "funnel",
    processType: "loanContracting",
});

export const catalogue = {
    [analyticsId.CONTRACT_EASY_LOAN_STEP_1_VIEW]: () => ({
        ...commonFields(),
        event_name: "step_simulator",
        pageName: "/loanContracting/step1/simulator",
        processStep: "step1",
        processDetail: "simulator",
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_2_VIEW]: ({ data }) => ({
        ...commonFields(),
        event_name: "step_ine",
        pageName: "/loanContracting/step2/loanContractingINE",
        processStep: "step2",
        processDetail: "loanContractingINE",
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_3_VIEW]: ({ data }) => ({
        ...commonFields(),
        event_name: "step_documentation",
        pageName: "/loanContracting/step3/documentation",
        processStep: "step3",
        processDetail: "documentation",
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_1_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "simulator",
        data: true,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_2_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "loanContractingINE",
        data: true,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_3_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "documentation",
    }),
    [analyticsId.CONTRACT_EASY_LOAN_WIZARD_ERROR]: ({
        data,
        errorMessage,
    }) => ({
        ...commonFields(),
        event_name: "step_error",
        pageName: "/loanContracting/error/deniedError",
        processStep: "error",
        processDetail: "deniedError",
        errorCategory: "deniedError",
        errorDescription: errorMessage,
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_WIZARD_SUCCESS]: ({ data }) => ({
        ...commonFields(),
        event_name: "step_application_success",
        pageName: "/loanContracting/applicationSuccess",
        processStep: "applicationSuccess",
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_WIZARD_NO_OFFER]: () => ({
        ...commonFields(),
        event_name: "step_application_no_offer",
        pageName: "/loanContracting/noOffer",
        processStep: "noOffer",
        productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
    }),
    [analyticsId.CLICK_BREADCRUMB_01]: () => ({
        categoriaEvento: window.utag_last_name,
        accionEvento: "préstamos e hipotecas",
        etiquetaEvento: "breadcrumb01",
    }),
};

const recordEasyLoanCPurpose = (tagEvent) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    analyticsId.PRUPOSE_DROPDOWN_EVENT,
    tagEvent
);

const recordEasyLoanCAmountFocus = (tagEvent) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    analyticsId.CLICK_TEXT_BOX_EVENT,
    tagEvent
)

export const recordEasyLoanTypeCContract = (tagEvent) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    "contractTypeDropdown",
    tagEvent
);

export const recordEasyLoanTypeCContractOpen = () => recordEasyLoanTypeCContract(TAG_EVENT_OPEN);
export const recordEasyLoanTypeCContractClose = () => recordEasyLoanTypeCContract(TAG_EVENT_CLOSE);

export const recordEasyLoanCApprovedEmploymentLevel = (tagEvent) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    "employmentLevelDropdown",
    tagEvent
);

export const recordEasyLoanCApprovedEmploymentLevelOpen = () => recordEasyLoanCApprovedEmploymentLevel(TAG_EVENT_OPEN);
export const recordEasyLoanCApprovedEmploymentLevelClose = () => recordEasyLoanCApprovedEmploymentLevel(TAG_EVENT_CLOSE);

export const recordEasyLoanCEmploymentStatus = (tagEvent) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    "employmentStatusDropdown",
    tagEvent
);

export const recordPurposeSelectChange = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    analyticsId.PRUPOSE_DROPDOWN_EVENT,
    "selection"
);

export const recordEasyLoanCPurposeFocus = () => recordEasyLoanCPurpose(TAG_EVENT_OPEN);
export const recordEasyLoanCPurposeBlur = () => recordEasyLoanCPurpose(TAG_EVENT_CLOSE);
export const recordEasyLoanCEmploymentStatusFocus = () => recordEasyLoanCEmploymentStatus(TAG_EVENT_OPEN);
export const recordEasyLoanCEmploymentStatusBlur = () => recordEasyLoanCEmploymentStatus(TAG_EVENT_CLOSE);
export const recordEasyLoanCMonthlyIncome = () => recordEasyLoanCAmountFocus("netIncomeTextBox")
export const recordEasyLoanCMonthlyExpenses = () => recordEasyLoanCAmountFocus("otherLoansExpensesTextBox");
export const recordEasyLoanCRentalExpenses = () => recordEasyLoanCAmountFocus("rentalExpensesTextBox");

export const recordEasyLoanCAmountValue = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    analyticsId.CLICK_TEXT_BOX_EVENT,
    'amountTextBox'
);

export const recordEasyLoanCTermValue = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    analyticsId.CLICK_TEXT_BOX_EVENT,
    'returnTimeTextBox'
);

export const recordEasyLoanCAuthorizationCheckbox = (isChecked) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    "cirbeAuthorizationCheckbox",
    isChecked ? analyticsId.TAG_CHECKED : analyticsId.TAG_UNCHECKED
);

export const recordEasyLoanCINEClick = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_LINK_EVENT,
    "ineLink"
);

export const recordEasyLoanCWizardCancel = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_LINK_EVENT,
    "cancel"
);

export const recordEasyLoanCWizardButton = (eventName) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_BUTTON_ACTION,
    eventName
);
    
export const recordEasyLoanCWizardNext = (amount) => {
    recordLinkV2({
        amount,
        categoriaEvento: CONTRACT_EASY_LOAN_CATEGORY_EVENT,
        accionEvento: CLICK_BUTTON_ACTION,
        etiquetaEvento: "next",
    })
}
export const recordEasyLoanCWizardPrevious = () => recordEasyLoanCWizardButton(TAG_PREVIOUS);
export const recordEasyLoanCWizardRequest = () => recordEasyLoanCWizardButton("request");
export const recordEasyLoanCWizardFinish = () => recordEasyLoanCWizardButton("finish");

export const recordEasyLoanCBannerMoreInfo = () => recordLink(
    "espacio obleas preaprobadoloan",
    "click",
    "mas informacion"
);

export const recordEasyLoanCBannerContinue = () => recordLinkV2({
    categoriaEvento: analyticsId.EASY_LOAN_REQUEST,
    accionEvento: CLICK_BUTTON_ACTION,
    etiquetaEvento: "continuar solicitud",
    nombreProducto: LOANS_MORTGAGES_EASY_LOAN_TYPE_C
});

export const recordEasyLoanCBannerCancel = () => recordLinkV2({
    categoriaEvento: analyticsId.EASY_LOAN_REQUEST,
    accionEvento: CLICK_LINK_EVENT,
    etiquetaEvento: "cancelar solicitud",
    nombreProducto: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
});

export const recordEasyLoanCBannerMoreInfoView = () => recordLinkV2({
    categoriaEvento: analyticsId.EASY_LOAN_REQUEST,
    accionEvento: TAGGING_VIEW,
    etiquetaEvento: "prestamo aprobado",
    nombreProducto: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
});

export const recordEasyLoanCOfferNotAvailableView = () => recordPage({
    ...commonFields(),
    event_name: "step_application_no_offer",
    pageName: "/loanContracting/noOffer",
    processStep: "noOffer",
    productName: LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
});

export const recordEasyLoanCBackGlobalPositionButton = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_LINK_EVENT,
    "returnToOverallPositionLink"
);

export const recordEasyLoanCINEButtons = (tagEvent) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_LINK_EVENT,
    tagEvent
);

export const recordEasyLoanCINEDownload = () => recordEasyLoanCINEButtons(TAG_DOWNLOAD);
export const recordEasyLoanCINEPrint = () => recordEasyLoanCINEButtons(TAG_PRINT);
export const recordEasyLoanCINEScroll = () => recordEasyLoanCINEButtons(analyticsId.TAG_SCROLL_TO_BOTTON);

export const recordEasyLoanCINECheckbox = (isChecked) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    "ineDocumentCheckbox",
    isChecked ? analyticsId.TAG_CHECKED : analyticsId.TAG_UNCHECKED
);

export const recordEasyLoanCUploadFile = (title) => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    "uploadDocument",
    title
);

export const recordEasyLoanCUploadFileSuccess = (title) => recordEasyLoanCUploadFile(`${title} success`);

export const recordEasyLoanCUpdateEmail = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_BUTTON_ACTION,
    'updateEmail'
);

export const recordEasyLoanCSendEmail = () => recordLink(
    CONTRACT_EASY_LOAN_CATEGORY_EVENT,
    CLICK_BUTTON_ACTION,
    'sendInfoByEmail'
);

